"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _Container = _interopRequireDefault(require("../common/Container"));
var _Version = _interopRequireDefault(require("./Version"));
var _Size = _interopRequireDefault(require("./Size"));
var _Downloads = _interopRequireDefault(require("./Downloads"));
var _jsxRuntime = require("react/jsx-runtime");
var Npm = function Npm(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container["default"], (0, _objectSpread2["default"])({}, props));
};
Npm.Version = _Version["default"];
Npm.Size = _Size["default"];
Npm.Downloads = _Downloads["default"];
Npm.displayName = 'Npm';
var _default = exports["default"] = Npm;
module.exports = exports.default;